import React, { memo } from "react";
import PT from "prop-types";
import * as S from "./styled";
import ShareIcon from "_c/icon/Share";
import StarIcon from "_c/icon/Star";
import MasterBadges from "_c/Master/Badges";
import { SITE_URL } from "@/misc/constants";
import { analyticsAction } from "@/utils/analytics";

export const Top = ({
  isFavorite,
  master,
  isOwner,
  name,
  openAuthModal,
  openShareModal,
  isAuth,
  isOnline,
  pageType,
  hl,
  toggleFavorite,
  t,
  shareId,
}) => {
  const onShare = () => {
    const base =
      pageType === "master" || pageType === "client" ? pageType : "salon";
    const link = `${SITE_URL}/${base}?id=${shareId}`;
    openShareModal(link);
    if (pageType === "saloon") {
      analyticsAction({
        category: "salon_profile",
        action: "salon_share",
      });
    } else {
      analyticsAction({
        category: "profile",
        action: "share",
      });
    }
  };
  return (
    <S.Line>
      <div
        css={`
          // display: flex;
          // flex-wrap: wrap;
          // align-items: center;
          margin-bottom: 10px;
        `}
      >
        <S.Name>{name}</S.Name>{" "}
        {pageType !== "saloon" && (
          <S.OnlineStatus
            title={t(`common:${isOnline ? "online" : "offline"}`)}
            isOnline={isOnline}
          />
        )}
      </div>
      <div
        css={`
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        `}
      >
        <S.LikeButton
          light
          onClick={isAuth ? toggleFavorite : openAuthModal}
          disabled={isOwner}
          aria-label={t(`common:${isFavorite ? "remove_like" : "like"}`)}
        >
          <StarIcon filled={isFavorite} color="var(--color-primary)" />
        </S.LikeButton>
        <S.ShareButton
          light
          id="profile__share"
          onClick={onShare}
          arial-label={t("common:share")}
        >
          <ShareIcon color="var(--color-primary)" />
        </S.ShareButton>
      </div>
      {pageType === "master" && master && (
        <MasterBadges
          css={`
            margin-bottom: 10px;
          `}
          hl={hl}
          t={t}
          master={master}
        />
      )}
    </S.Line>
  );
};
Top.displayName = "ProfileTop";
Top.propTypes = {
  isOnline: PT.bool,
  isOwner: PT.bool,
  isFavorite: PT.bool,
  user: PT.object,
  master: PT.object,
  isAuth: PT.bool.isRequired,
  pageType: PT.oneOf(["master", "client", "saloon"]).isRequired,
  hl: PT.string,

  sendMessage: PT.func.isRequired,
  t: PT.func.isRequired,
  openShareModal: PT.func.isRequired,
  openAuthModal: PT.func.isRequired,
};

export default memo(Top);
